import { type FunctionComponent } from 'react';
import { type LocationMarker } from '../../types/google-maps.types';
import { Map } from './map/map.component';

export type GoogleMapProps = {
	mapTypeControl?: boolean;
	markers?: LocationMarker[];
	center?: LocationMarker;
	searchAddress?: string;
};

export const GoogleMap: FunctionComponent<GoogleMapProps> = ({ center, markers, searchAddress, mapTypeControl = false }) => {
	return (
		<div className="map-container flex justify-center pa3" data-testid="google-map">
			<Map center={center} searchAddress={searchAddress} mapTypeControl={mapTypeControl} markers={markers} />
		</div>
	);
};
